import { invert } from 'lodash';
import { useEffect, useState, useContext, useRef } from 'react';
import { useLocation } from 'react-router';

import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import CaretLeft from 'components/icons/navigation/CaretLeft';
import { BrandContext } from 'context/BrandContext';
import { funnelSteps, getBrandRoute } from 'helpers/routes';
import useFamilyCTA from 'hooks/useFamilyCTA';
import useFunnelMealPlan from 'hooks/useFunnelMealPlan';
import { FAMILY } from 'lib/constants';

import { UserContext } from './Contexts';

const BackButton = () => {
  const { brand } = useContext(BrandContext);
  const { user } = useContext(UserContext);
  const location = useLocation();
  const mealPlanSlug = useFunnelMealPlan();
  const isFamilyMealPlan = mealPlanSlug === FAMILY;
  const fromFamilyCTA = useFamilyCTA();
  const initialParamsRef = useRef(null);

  if (!initialParamsRef.current) {
    initialParamsRef.current = location.search;
  }
  const brandRoutes = getBrandRoute({ brand: brand, isFamily: isFamilyMealPlan });
  const [previousFunnelStep, setPreviousFunnelStep] = useState(brandRoutes.intro);

  useEffect(() => {
    const funnelStepsConfig = funnelSteps({
      brand,
      isFamily: isFamilyMealPlan,
    });
    const currentFunnelStep = funnelStepsConfig[location.pathname];

    if (currentFunnelStep === funnelStepsConfig[brandRoutes.billing]) {
      setPreviousFunnelStep(brandRoutes.box);
    } else if (location.pathname === brandRoutes.pickPlan) {
      setPreviousFunnelStep(brandRoutes.intro);
    } else if (location.pathname.includes('/box-people') && isFamilyMealPlan) {
      setPreviousFunnelStep(brandRoutes.preferenceAvoid);
    } else if (
      (location.pathname === brandRoutes.preferenceDietary && user?.hidePlanChangePage) ||
      fromFamilyCTA
    ) {
      setPreviousFunnelStep(brandRoutes.intro);
    } else {
      setPreviousFunnelStep(invert(funnelStepsConfig)[currentFunnelStep - 1] || brandRoutes.intro);
    }
  }, [
    location.pathname,
    brand,
    user?.hidePlanChangePage,
    isFamilyMealPlan,
    brandRoutes,
    fromFamilyCTA,
    user?.recommendedMealPlan,
  ]);

  if (
    location.pathname.includes(brandRoutes.intro) ||
    location.pathname.includes(brandRoutes.thankyou)
  ) {
    return <div className="h-4 w-4 bp1:w-16"></div>;
  } else {
    return (
      <div className="flex items-center">
        <DefaultLink
          to={previousFunnelStep + (initialParamsRef.current || '')}
          className="flex items-center pr-0 text-xs font-medium bp1:pl-5"
        >
          <CaretLeft className="text-secondary h-6 w-6 bp1:h-5 bp1:w-5" />
          <Text
            htmlElement="span"
            // on mobile we want the BACK text to be visible for sr but on mobile we want it visible
            className="sr-only uppercase bp1:not-sr-only"
            style={{ paddingLeft: '0.25rem' }}
          >
            Back
          </Text>
        </DefaultLink>
      </div>
    );
  }
};

export default BackButton;
